<script>
  import { createEventDispatcher } from 'svelte';

  export let label;
  export let value;
  export let placeholder = null;
  export let id = null;
  export let style = null;
  export let valid = true;
  export let errorMessage = null;
  export let readonly = false;

  const dispatch = createEventDispatcher();

  const selectText = (e) => {
    if (selectTextOnFocus) {
      e.toElement.select();
    }
    dispatch('click');
  };

  let noOutline = true;
  let canShowError = false;

  const blur = function onBlurAllowErrorToBeDisplayedAndDispatchBlur() {
    dispatch('blur');
    if (value) canShowError = true;
  };
</script>

<div class="wrapper">
  <input
    bind:value
    on:focus
    on:blur={blur}
    on:input
    on:keyup
    {placeholder}
    type="text"
    required={true}
    on:click={selectText}
    {id}
    class:no-outline={noOutline}
    class:opened-input={value}
    class:input-error={canShowError && !valid}
    {style}
    {readonly}
  />

  <label class:opened-label={value}> {label} </label>

  {#if canShowError && !valid}
    <p class="error-message">{errorMessage}</p>
  {/if}
</div>

<style>
  .wrapper {
    position: relative;
    width: 100%;
  }
  h4,
  input,
  label {
    font-weight: 600;
    font-size: 0.9rem;
    margin: 0;
    outline: none;
    color: #ffffff;
  }
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #ffffff;
    opacity: 0.7; /* Firefox */
  }
  input {
    box-sizing: border-box;
    padding-left: 0.9rem;
    background-color: #0b1220;
    border: none;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1), inset 0px 0px 0px 0.0625em #33414f;
    width: 100%;
    border-radius: 10px;
    height: 3em;
    transition: 0.2s ease box-shadow, 0.1s ease padding-top, 0.1s ease height;
    color: #ffffff;
  }
  label {
    position: absolute;
    left: 1.2em;
    top: 1em;
    transition: 0.2s ease all;
    pointer-events: none;
  }
  input:focus ~ label,
  .opened-label {
    top: 0.5em;
    font-size: 0.75em;
    font-weight: 400;
    opacity: 0.8;
  }
  input:focus,
  .opened-input {
    padding-top: 1em;
  }
  input:focus {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1), inset 0px 0px 0px 0.125em #423fd6;
  }
  .input-error {
    box-shadow: inset 0 0 0 0.15em #cd4d4d;
  }
  .error-message {
    color: #cd4d4d;
    font-size: 0.8em;
    margin: 0;
    padding: 0;
    margin-top: 0.4em;
  }
</style>
